import { useEffect, useState } from 'react';
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

const DirectionsRenderer = ({ origin, destination, waypoints = [], travelMode = 'DRIVING', strokeColor = '#3B82F6', strokeWeight = 4, strokeOpacity = 0.8 }) => {
  const map = useMap();
  const routesLibrary = useMapsLibrary('routes');
  const [directionsService, setDirectionsService] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);

  // Inicialize the directions service and renderer when the map and routes library are available. 
  useEffect(() => {
    if (!routesLibrary || !map) return;

    const service = new routesLibrary.DirectionsService();
    const renderer = new routesLibrary.DirectionsRenderer({
      map: map,
      suppressMarkers: true, // Não mostrar marcadores padrão
      polylineOptions: {
        strokeColor: strokeColor,
        strokeWeight: strokeWeight,
        strokeOpacity: strokeOpacity
      }
    });

    setDirectionsService(service);
    setDirectionsRenderer(renderer);
  }, [routesLibrary, map, strokeColor, strokeWeight, strokeOpacity]);

  // Calculate and render the route when origin, destination, or waypoints change
  useEffect(() => {
    if (!directionsService || !directionsRenderer || !origin || !destination) return;

    const request = {
      origin: origin,
      destination: destination,
      waypoints: waypoints.map(point => ({ location: point, stopover: false })),
      travelMode: window.google?.maps?.TravelMode?.[travelMode] || 'DRIVING',
      unitSystem: window.google?.maps?.UnitSystem?.METRIC,
      avoidHighways: false,
      avoidTolls: false
    };

    directionsService.route(request, (result, status) => {
      if (status === 'OK') {
        directionsRenderer.setDirections(result);
        console.log(`Rota carregada: ${origin.lat},${origin.lng} → ${destination.lat},${destination.lng}`);
      } else {
        console.error('Erro ao calcular rota:', status);
      }
    });

    // Cleanup quando o componente for desmontado
    return () => {
      if (directionsRenderer) {
        directionsRenderer.setMap(null);
      }
    };
  }, [directionsService, directionsRenderer, origin, destination, waypoints, travelMode]);

  // Este componente não renderiza nada visualmente, apenas gerencia as rotas
  return null;
};

export default DirectionsRenderer; 